import React, { useEffect, useState } from 'react';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../../hooks/useAuthorizedRequest';
import { generateAxiosInstanceCommon } from '../../hooks/useAuthorizedReuestCommon';
import { generateAxiosInstanceInstitute } from '../../hooks/useAuthorizedRequestForInstitute';
import ViewImageAndText from '../../components/ViewImageAndText';
import VidyaUpasnaLogo from '../../assets/VidyaUpasna.jpg';
import { CModal } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../../components/ModalsCommonFunctions';
import { deleteItem, findPageNumber, searchArray, SortIcon } from '../../components/Navigation';
import Pagination from '../../components/Pagination';
import ViewImageAndTextQuetionBank from '../../components/ViewImageAndTextQuetionBank';

const InstituteViewTextBook = () => {
    const authorizedAxios = generateAxiosInstance();
    const authorizedAxiosCommon = generateAxiosInstanceCommon();
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute();
    const instituteMasterId = localStorage.getItem("instituteMasterId");
    const instituteName = localStorage.getItem("instituteName");
    const instituteLogo = localStorage.getItem("logoPath");
    const [questions, setQuestion] = useState([]);
    const [editId, setEditId] = useState(null);
    const [syllabusList, setSyllabusList] = useState([]);
    const [subjectList, setSubjectList] = useState([])
    const [topicList, setTopicList] = useState([])
    const [lessonList, setLessonList] = useState([])
    const [subTopicViewtopicList, setSubTopicViewtopicList] = useState([])
    const [visible, setVisible] = useState(false)
    const [modalData, setModalData] = useState("")

    const initialFormState = {
        q_level: '',
        q_type: '',
        question: '',
        option_a: '',
        option_b: '',
        option_c: '',
        option_d: '',
        ans: '',
        sol: ''
    }

    const initialFilterState = {
        instituteSyllabusStructureMasterId: '',
        instituteLessonMasterId: '',
        instituteTopicMasterId: '',
        instituteSubTopicMasterId: '',
        subTopicName: '',
        instituteSubjectMasterId: ''
    }

    const [filter, setFilter] = useState(initialFilterState);
    const [editAns, setEditAns] = useState(initialFormState);
    const [visibleImage, setVisibleImage] = useState(false);
    const [modalImageSrc, setModalImageSrc] = useState('');
    const [syType, setSyType] = useState("")

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    // const [questionLevelSort, setQuestionLevelSort] = useState(null);
    // const [questionTypeSort, setQuestionTypeSort] = useState(null);
    // const [questionSort, setQuestionSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = ["question", "option_a", "option_b", "option_c", "option_d", "ans", "sol"];

    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    const onViewImage = (imgSrc) => {
        setModalImageSrc(imgSrc);
        setVisibleImage(true);
    };

    useEffect(() => {
        getSyllabusList();
    }, []);

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getQuestionAnswerList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            if (syType == "A") {
                setQuestion(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim(), "data"))
            } else if (syType == "I") {
                setQuestion(await searchArray("I", getApiUrl(), searchKeys, searchValue.trim(), "data"))
            }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(questions, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(questions.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > questions.length) {
            endIndex = questions.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(questions.slice(startIndex, endIndex));
    }, [questions, currPage, itemsPerPage]);

    useEffect(() => {
        if (filter.instituteSyllabusStructureMasterId.length !== 0 && filter.instituteSubjectMasterId.length !== 0) {
            getQuestionAnswerList();
        }
    }, [filter]);

    const getApiUrl = () => {
        if (syType === "A") {
            let apiUrl = `/get-question-bank?`;
            if (filter.instituteSyllabusStructureMasterId) {
                apiUrl += `syllabusStructureMasterId=${filter.instituteSyllabusStructureMasterId}&`;
            }
            if (filter.instituteSubjectMasterId) {
                apiUrl += `subjectMasterId=${filter.instituteSubjectMasterId}&`
            }
            if (filter.instituteLessonMasterId) {
                apiUrl += `lessonMasterId=${filter.instituteLessonMasterId}&`;
            }
            if (filter.instituteTopicMasterId) {
                apiUrl += `topicMasterId=${filter.instituteTopicMasterId}&`;
            }
            if (filter.instituteSubTopicMasterId) {
                apiUrl += `subTopicMasterId=${filter.instituteSubTopicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        } else if (syType === "I") {
            let apiUrl = `/get-institute-question-bank?instituteMasterId=${instituteMasterId}&`;

            if (filter.instituteSyllabusStructureMasterId) {
                apiUrl += `instituteSyllabusStructureMasterId=${filter.instituteSyllabusStructureMasterId}&`;
            }
            if (filter.instituteSubjectMasterId) {
                apiUrl += `instituteSubjectMasterId=${filter.instituteSubjectMasterId}&`
            }
            if (filter.instituteLessonMasterId) {
                apiUrl += `instituteLessonMasterId=${filter.instituteLessonMasterId}&`;
            }
            if (filter.instituteTopicMasterId) {
                apiUrl += `instituteTopicMasterId=${filter.instituteTopicMasterId}&`;
            }
            if (filter.instituteSubTopicMasterId) {
                apiUrl += `instituteSubTopicMasterId=${filter.instituteSubTopicMasterId}&`;
            }

            apiUrl = apiUrl.replace(/&$/, '');
            return apiUrl;
        }
    }

    const getQuestionAnswerList = async () => {
        if (filter.instituteSyllabusStructureMasterId.length !== 0 && filter.instituteSubjectMasterId.length !== 0) {
            try {
                if (syType == "A") {
                    const response = await authorizedAxios.get(getApiUrl())
                    setQuestion(response.data.data)
                }

                if (syType == "I") {
                    const response = await authorizedAxiosInstitute.get(getApiUrl())
                    setQuestion(response.data.data)
                }
            } catch (error) {
                setQuestion([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        }
    }

    const getSyllabusList = () => {
        const apiUrlForSyllabus = `/get-all-syllabus-structure?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosCommon && authorizedAxiosCommon.get(apiUrlForSyllabus)
            .then(response => {
                setSyllabusList(response.data.result)
            })
            .catch(error => {
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleSyllabusChange = (e) => {
        const value = e.target.value;
        const id = value.slice(0, -1); // Extract ID part
        const type = value.slice(-1);  // Extract type part (I or A)

        // Update syllabus type
        setSyType(type);

        // Update filter state
        setFilter(prevData => ({
            ...prevData,
            [e.target.name]: id,
            instituteLessonMasterId: '',
            instituteTopicMasterId: '',
            instituteSubTopicMasterId: '',
            instituteSubjectMasterId: ''
        }));

        // Reset lists
        setLessonList([]);
        setTopicList([]);
        setSubTopicViewtopicList([]);

        // Axios instances and URLs
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrls = {
            I: `get-institute-syllabus-structure-Wise-institute-subjects?id=${id}`,
            A: `/syllabus-structure-wise-subjects?id=${id}`
        };

        const axiosInstance = axiosInstances[type];
        const apiUrl = apiUrls[type];

        // Fetch data if axiosInstance is valid
        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubjectList(response.data.result); // Set subject list from API response
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };

    const handleSubjectChange = (e) => {
        const { name, value } = e.target;

        // Update filter state
        setFilter((prevData) => ({
            ...prevData,
            [name]: value,
            instituteLessonMasterId: '',
            instituteTopicMasterId: '',
            instituteSubTopicMasterId: '',
        }));

        // Reset lists
        setTopicList([]);
        setSubTopicViewtopicList([]);

        // Define axios instances for each type
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        // Define API URLs for each type
        const apiUrls = {
            I: `/get-institute-subject-wise-institute-lesson?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${filter.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${value}`,
            A: `/subject-wise-lesson?syllabusStructureMasterId=${filter.instituteSyllabusStructureMasterId}&subjectMasterId=${value}`
        };

        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];

        // Make the request if axiosInstance is defined
        if (axiosInstance && apiUrl) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setLessonList(response.data.result);
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };

    const handleLessonChange = (e) => {
        const { name, value } = e.target;

        // Update filter state
        setFilter(prevData => ({
            ...prevData,
            [name]: value,
            instituteTopicMasterId: '',
            instituteSubTopicMasterId: ''
        }));

        // Reset subtopic list
        setSubTopicViewtopicList([]);

        // Define axios instances and API URLs
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrls = {
            I: `/get-institute-lesson-wise-institute-sub-topic?id=${value}`,
            A: `/lesson-wise-topic?id=${value}`
        };

        // Get the appropriate axios instance and API URL based on `syType`
        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];

        // Fetch data if axiosInstance is valid
        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setTopicList(response.data.result); // Set topic list from API response
                })
                .catch(error => {
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };

    const handleTopicChange = (e) => {
        const { name, value } = e.target;

        // Update filter state
        setFilter(prevData => ({
            ...prevData,
            [name]: value,
            instituteSubTopicMasterId: ''
        }));

        // Define axios instances and API URLs
        const axiosInstances = {
            I: authorizedAxiosInstitute,
            A: authorizedAxios
        };

        const apiUrls = {
            I: `/get-institute-sub-topic-master?instituteMasterId=${instituteMasterId}&instituteSyllabusStructureMasterId=${filter.instituteSyllabusStructureMasterId}&instituteSubjectMasterId=${filter.instituteSubjectMasterId}&instituteLessonMasterId=${filter.instituteLessonMasterId}&instituteTopicMasterId=${value}`,
            A: `/get-sub-topic-master-list?syllabusStructureId=${filter.instituteSyllabusStructureMasterId}&subjectMasterId=${filter.instituteSubjectMasterId}&lessonId=${filter.instituteLessonMasterId}&topicId=${value}`
        };

        // Get the appropriate axios instance and API URL based on `syType`
        const axiosInstance = axiosInstances[syType];
        const apiUrl = apiUrls[syType];

        // Fetch subtopics if axiosInstance is valid
        if (axiosInstance) {
            axiosInstance.get(apiUrl)
                .then(response => {
                    setSubTopicViewtopicList(response.data.result); // Set subtopic list from API response
                })
                .catch(error => {
                    setSubTopicViewtopicList([]); // Reset subtopic list on error
                    const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                    console.error('Error fetching data:', errorMsg);
                });
        }
    };


    const handleInputChangeFilter = (e) => {
        setFilter((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }


    const handleReset = () => {
        setFilter(initialFilterState);
        setEditId(null);
        setEditAns(initialFormState);
        setQuestion([]);
        setSubjectList([]);
        setLessonList([]);
        setTopicList([]);
        setSubTopicViewtopicList([]);
        setVisible(false);
        setSyType("");
    }


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <div id='scroll-up'></div>
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/institute-dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>View Text Book Question Bank</span></li>
                        </ol>
                    </nav>
                </div>
                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa fa-eye"></i> View Text Book Question Bank</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label">Select Syllabus Structure :</label>
                                                    <select required class="form-select" aria-label="Default select example" name='instituteSyllabusStructureMasterId' onChange={handleSyllabusChange} value={filter.instituteSyllabusStructureMasterId + syType}>
                                                        <option selected value={''}>Select Syllabus</option>
                                                        {
                                                            syllabusList?.map((syllabus) => {
                                                                return <option style={{ color: syllabus.type == "I" ? "blue" : syllabus.type == "B" ? "red" : '' }} value={syllabus?.id + syllabus?.type}>{syllabus?.syllabusStructureName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>

                                                {syType == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={filter.instituteSubjectMasterId}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    return <option value={syllabus?.subjectMasterDetails?.id}>{syllabus?.subjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syType == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Subject :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='instituteSubjectMasterId' onChange={handleSubjectChange} value={filter.instituteSubjectMasterId}>
                                                            <option selected value={''} disabled>Select Subject</option>
                                                            {
                                                                subjectList?.map((syllabus) => {
                                                                    return <option value={syllabus?.instituteSubjectMasterDetails?.id}>{syllabus?.instituteSubjectMasterDetails?.subjectName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syType == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='instituteLessonMasterId' onChange={handleLessonChange} value={filter.instituteLessonMasterId}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonList?.map((lesson) => {
                                                                    return <option value={lesson.id}>{lesson.lessonName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syType == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Lesson :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='instituteLessonMasterId' onChange={handleLessonChange} value={filter.instituteLessonMasterId}>
                                                            <option selected value={''} disabled>Select Lesson</option>
                                                            {
                                                                lessonList?.map((lesson) => {
                                                                    return <option value={lesson.id}>{lesson.instituteLessonName}</option>
                                                                })
                                                            }
                                                        </select>

                                                    </div>
                                                </>}

                                                {syType == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='instituteTopicMasterId' onChange={handleTopicChange} value={filter.instituteTopicMasterId}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicList?.map((topic) => {
                                                                    return <option value={topic.id}>{topic.topicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syType == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='instituteTopicMasterId' onChange={handleTopicChange} value={filter.instituteTopicMasterId}>
                                                            <option selected value={''} disabled>Select Topic</option>
                                                            {
                                                                topicList?.map((topic) => {
                                                                    return <option value={topic.id}>{topic.instituteTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syType == "A" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='instituteSubTopicMasterId' onChange={handleInputChangeFilter} value={filter.instituteSubTopicMasterId}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subTopicViewtopicList?.map((topic) => {
                                                                    return <option value={topic.id}>{topic.subTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {syType == "I" && <>
                                                    <div className="col-md-6">
                                                        <label for="inputPassword" className="col-form-label">Select Sub Topic :</label>
                                                        <select required class="form-select" aria-label="Default select example" name='instituteSubTopicMasterId' onChange={handleInputChangeFilter} value={filter.instituteSubTopicMasterId}>
                                                            <option selected value={''} disabled>Select Sub Topic</option>
                                                            {
                                                                subTopicViewtopicList?.map((topic) => {
                                                                    return <option value={topic.id}>{topic.instituteSubTopicName}</option>
                                                                })
                                                            }
                                                        </select>
                                                    </div>
                                                </>}

                                                {!editId && <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={handleReset}>Reset</button>
                                                    </div>
                                                </div>}

                                                {/* {editAns.question !== '' && <>
                                                    <div className='row'>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Level :</label>
                                                            <input required type="text" className="form-control" id="q_level" name='q_level' onChange={handleInputChange} value={editAns.q_level} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question Type :</label>
                                                            <input required type="text" className="form-control" id="q_type" name='q_type' onChange={handleInputChange} value={editAns.q_type} />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className="col-md-12">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Question :</label>
                                                            <input required type="text" className="form-control" id="question" name='question' onChange={handleInputChange} value={editAns.question} />
                                                        </div>
                                                    </div>

                                                    <div className='row'>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option A :</label>
                                                            <input required type="text" className="form-control" id="option_a" name='option_a' onChange={handleInputChange} value={editAns.option_a} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option B :</label>
                                                            <input required type="text" className="form-control" id="option_b" name='option_b' onChange={handleInputChange} value={editAns.option_b} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option C :</label>
                                                            <input required type="text" className="form-control" id="option_c" name='option_c' onChange={handleInputChange} value={editAns.option_c} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Option D :</label>
                                                            <input required type="text" className="form-control" id="option_d" name='option_d' onChange={handleInputChange} value={editAns.option_d} />
                                                        </div>
                                                        <div className='row'>
                                                            <div className="col-md-12">
                                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Answer :</label>
                                                                <input required type="text" className="form-control" id="sol" name='ans' onChange={handleInputChange} value={editAns.ans} />
                                                            </div>
                                                            <div className="col-md-12">
                                                                <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Solution :</label>
                                                                <input required type="text" className="form-control" id="sol" name='sol' onChange={handleInputChange} value={editAns.sol} />
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>

                                                        <div className="col-auto">
                                                            <button className="btn btn-primary" type="button" style={{ marginRight: '20px' }} onClick={() => updateSubtopic()} >Update</button>
                                                            <button className="btn btn-outline-danger delete_icon" type="button" style={{ marginRight: '20px' }} onClick={() => { setEditAns(initialFormState); setSyType("") }}>Reset</button>
                                                        </div>
                                                    </div>
                                                </>} */}



                                                {filter.instituteSubjectMasterId !== "" &&

                                                    <div className='row'>
                                                        <div className="separator"></div>
                                                        <div className="d-grid gap-2 mt-2">
                                                            {displayedData.length > 0 ?
                                                                <>
                                                                    <div className='search_btn_row'>
                                                                        <input
                                                                            className="form-control mr-sm-2"
                                                                            type="Search"
                                                                            placeholder="Search"
                                                                            value={searchValue}
                                                                            onChange={handleEmptySearch}
                                                                            onKeyDown={(event) => {
                                                                                if (event.key === 'Enter') {
                                                                                    handleSearch();
                                                                                }
                                                                            }}
                                                                        />
                                                                        <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                                    </div>
                                                                    <div class="generate_pdf_question_paper_report_block" id="examReportContent">
                                                                        <div class="generate_pdf_question_paper_heading">
                                                                            <div class="generate_pdf_question_paper_logo">
                                                                                {/* <img src={displayedData[0]?.instituteMasterDetails?.logoPath} alt="Institute Logo" /> */}
                                                                                <img src={VidyaUpasnaLogo} alt="VidyaUpasna Logo" />
                                                                            </div>
                                                                            <div class="text_center">
                                                                                {/* <h6>{displayedData[0]?.instituteMasterDetails?.instituteName}</h6> */}
                                                                                {/* <h4>{displayedData[0]?.sectionMasterDetails?.sectionName}</h4> */}
                                                                                <h4>{instituteName}</h4>
                                                                            </div>
                                                                            <div class="generate_pdf_question_paper_logo">
                                                                                {/* <img src={displayedData[0]?.instituteMasterDetails?.logoPath} alt="Institute Logo" /> */}
                                                                                <img src={instituteLogo} alt="Institute Logo" />
                                                                            </div>
                                                                        </div>

                                                                        <div class="generate_pdf_question_paper_report_code">
                                                                            <span class="line"></span>
                                                                        </div>

                                                                        <div class="generate_pdf_question_paper_details">
                                                                            <span>Syllabus: {syType == "A" ? displayedData[0]?.syllabusStructureMasterDetails?.syllabusStructureName : displayedData[0]?.instituteSyllabusStructureMasterDetails?.instituteSyllabusStructureName}</span>
                                                                            <span>Subject: {syType == "A" ? displayedData[0]?.subjectMasterDetails?.subjectName : displayedData[0]?.instituteSubjectMasterDetails?.subjectName}</span>
                                                                            {/* <span>Lesson: {pdfDetails?.examTotalMarks}</span> */}
                                                                        </div>


                                                                        <ol className="generate_pdf_question_paper_generated_pdf_total_question">
                                                                            {displayedData?.map((question, index) => {
                                                                                return (
                                                                                    <>
                                                                                        {index == 0 && <div class="generate_pdf_question_paper_details">
                                                                                            <span>Lesson: {syType == "A" ? question?.lessonMasterDetails?.lessonName : question?.instituteLessonMasterDetails?.instituteLessonName}</span>
                                                                                        </div>}
                                                                                        {index !== 0 && (syType == "A" ? (displayedData[index - 1].lessonMasterId !== question.lessonMasterId) : (displayedData[index - 1].instituteLessonMasterId !== question.instituteLessonMasterId)) && <div class="generate_pdf_question_paper_details">
                                                                                            <span>Lesson: {syType == "A" ? question?.lessonMasterDetails?.lessonName : question?.instituteLessonMasterDetails?.instituteLessonName}</span>
                                                                                        </div>}
                                                                                        <li key={index} className="generate_pdf_question_paper_question pdf-question-paper-listed-outer">
                                                                                            {/* <p>{question.question}</p> */}
                                                                                            {/* <p> */}
                                                                                            {/* <strong>{startIndex + index + 1}. </strong> */}
                                                                                            {/* <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} /> */}
                                                                                            {/* </p> */}

                                                                                            <div className='card-question-header'>
                                                                                                <span className="list-number">{startIndex + index + 1}.</span>
                                                                                                <ViewImageAndTextQuetionBank inputString={question.question} onViewImage={onViewImage} />
                                                                                            </div>
                                                                                            <ul className='margin-top-10'>
                                                                                                {['option_a', 'option_b', 'option_c', 'option_d'].map((optionKey, optionIndex) => {
                                                                                                    const optionLetter = String.fromCharCode(65 + optionIndex); // A, B, C, D
                                                                                                    // const isCorrect = question.ans.split(',').includes(String.fromCharCode(97 + optionIndex)); // Checking if the answer matches
                                                                                                    return (
                                                                                                        <li key={optionIndex} data-option={optionLetter} /*className={isCorrect ? "correct" : ""}*/>
                                                                                                            {/* {question[optionKey]} */}
                                                                                                            <ViewImageAndTextQuetionBank inputString={question[optionKey]} onViewImage={onViewImage} />
                                                                                                        </li>
                                                                                                    );
                                                                                                })}
                                                                                            </ul>
                                                                                            <p className="pdf-highlight"><strong>Correct Answer:</strong> {question.ans.toUpperCase()}</p>
                                                                                            <p className="pdf-highlight"><strong>Solution:</strong><ViewImageAndTextQuetionBank inputString={question.sol} onViewImage={onViewImage} /></p>
                                                                                        </li>
                                                                                    </>
                                                                                )
                                                                            })}
                                                                        </ol>

                                                                    </div>
                                                                    <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={questions.length} />
                                                                </>
                                                                :
                                                                (<div className='row'>
                                                                    <th colspan={"100%"} style={{ textAlign: 'center' }}>No Questions Available</th>
                                                                </div>)}
                                                        </div>
                                                    </div>

                                                }

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />

            {visible && <CModal
                visible={visible}
                onClose={() => setVisible(false)}
                aria-labelledby="LiveDemoExampleLabel"
                onIni
            >
                <div className="book book-modal">
                    <h2 className='table-header-like'> Solution</h2>
                    <div className="page" dangerouslySetInnerHTML={{
                        __html: `<style>.ckContent img{max-width:100% !important; height: auto !important}</style><div class="ck-content">${modalData}</div>`
                    }}></div>

                    <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisible(false)}>
                        Close
                    </button>
                </div>

            </CModal>}

            {visibleImage && (
                <CModal
                    visible={visibleImage}
                    onClose={() => setVisibleImage(false)}
                    aria-labelledby="LiveDemoExampleLabel"
                >
                    <div className="book book-modal">
                        <div className='table-header-like'>Image</div>
                        {modalImageSrc && <div className='page' dangerouslySetInnerHTML={{ __html: modalImageSrc }}></div>}
                        <button className="btn btn-outline-warning edit_icon" type="button" onClick={() => setVisibleImage(false)}>
                            Close
                        </button>
                    </div>
                </CModal>
            )}
        </>
    )
};

export default InstituteViewTextBook;
